if (!customElements.get('pulse-media-showcase')) {
  class PulseMediaShowcase extends HTMLElement {
    connectedCallback() {
      if (this.dataset.animate === 'false') return;

      const cards = this.querySelectorAll('.pms__card[data-animate]');
      if (!cards.length) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const card = entry.target;
            const index = parseInt(card.dataset.index || '0', 10);
            setTimeout(() => {
              card.classList.add('pms--visible');
            }, index * 80);
            observer.unobserve(card);
          });
        },
        { threshold: 0.12 }
      );

      cards.forEach((card, i) => {
        card.dataset.index = i;
        observer.observe(card);
      });
    }
  }

  customElements.define('pulse-media-showcase', PulseMediaShowcase);
}
